import { useDispatch, useSelector } from "react-redux";
import ButtonLoader from "../../../UI/Loaders/Loaders";
import { useEffect, useLayoutEffect, useState } from "react";
import { clearDocumentViewModalRecord } from "../../../redux/actions/documenViewer";
import { MixPanel } from "../../../shared/MixPanel/MixPanel";
import { Document, Page, pdfjs } from "react-pdf";

// Required for pdfjs worker
pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

const DocumentViewerModal = ({
  dataRecord: { documentUrl, type },
  onCloseModal,
}) => {
  const [documentData, setDocumentData] = useState({
    documentUrl: documentUrl,
    type: type,
    isLoading: true,
  });

  const [numPages, setNumPages] = useState(null);

  // console.log("Viewer", documentUrl)
  const dispatch = useDispatch();

  useEffect(() => {
    MixPanel.track(`Page View: DocumentViewer.tsx`, {
      page: "DocumentViewer.tsx",
    });
  }, []);

  const updatedDocumentData = useSelector(
    (state) => state?.documentViewerReducer,
  );

  useLayoutEffect(() => {
    if (updatedDocumentData?.documentUrl) {
      setDocumentData({
        documentUrl: updatedDocumentData?.documentUrl,
        type: updatedDocumentData?.type,
        isLoading: updatedDocumentData?.isLoading,
      });
    }
  }, [updatedDocumentData]);

  const onDocumentLoadSuccess = ({ numPages }) => {
    setNumPages(numPages);
  };

  return (
    <div
      className="Modal__dialog lg-modal animated slideInDown"
      role="document"
    >
      <div className="LoanModal Modal__content">
        <div className="Modal__body" style={{ overflow: "hidden" }}>
          <h3 className="Modal__title p-b-1"></h3>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
            }}
          >
            {documentData?.isLoading ? (
              <ButtonLoader />
            ) : (
              <>
                {/* Image preview */}
                {documentData?.type?.startsWith("image/") && (
                  <img
                    src={documentData?.documentUrl}
                    alt="Preview"
                    style={{
                      maxWidth: "1000px",
                      maxHeight: "800px",
                      objectFit: "contain",
                    }}
                  />
                )}

                {/* PDF preview (react-pdf) */}
                {documentData?.type === "application/pdf" && (
                  <div
                    style={{
                      width: "1000px",
                      height: "800px",
                      overflow: "auto",
                    }}
                  >
                    <Document
                      file={documentData?.documentUrl}
                      onLoadSuccess={onDocumentLoadSuccess}
                      loading={<ButtonLoader />}
                    >
                      {Array.from(new Array(numPages), (el, index) => (
                        <Page
                          key={`page_${index + 1}`}
                          pageNumber={index + 1}
                          width={900}
                        />
                      ))}
                    </Document>
                  </div>
                )}

                {/* PDF preview */}
                {/* {documentData?.type === "application/pdf" && (
                  <embed
                    src={documentData?.documentUrl}
                    type="application/pdf"
                    width="1000"
                    height="800"
                    style={{ border: "none" }}
                    title="PDF Viewer"
                  />
                )} */}

                {/* Word/Excel/PowerPoint */}
                {(documentData?.type?.includes("word") ||
                  documentData?.type?.includes("excel") ||
                  documentData?.type?.includes("presentation")) && (
                  <iframe
                    src={`https://view.officeapps.live.com/op/embed.aspx?src=${encodeURIComponent(
                      documentData?.documentUrl,
                    )}`}
                    width="1000"
                    height="800"
                    style={{ border: "none" }}
                    title="Office Document Viewer"
                  />
                )}

                {/* Fallback for unknown types */}
                {!documentData?.type?.startsWith("image/") &&
                  documentData?.type !== "application/pdf" &&
                  !(
                    documentData?.type?.includes("word") ||
                    documentData?.type?.includes("excel") ||
                    documentData?.type?.includes("presentation")
                  ) && (
                    <object
                      type={documentData?.type}
                      data={documentData?.documentUrl}
                      width="1000"
                      height="800"
                      style={{ objectFit: "contain" }}
                    >
                      <p>
                        Cannot preview this file.{" "}
                        <a
                          href={documentData?.documentUrl}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          Download instead
                        </a>
                      </p>
                    </object>
                  )}
              </>
            )}
          </div>
          <div className="Form__action-buttons m-t-2">
            <button
              type="button"
              className="btn zoom-element btn login-btn"
              onClick={() => {
                onCloseModal();
                dispatch(clearDocumentViewModalRecord());
              }}
              data-dismiss="modal"
            >
              <i className="fas fa-times-circle"></i>
              &nbsp; Close
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DocumentViewerModal;
